import * as colocAuthApi from '@/lib/coloc-api/auth';

export const { getUser, signOutUser } = colocAuthApi;
